export enum NAME_PARENT_COMPONENT {
  MAIN_DESKTOP = 'mainDesktop',
  MAIN_MOBILE = 'mainMobile',
  DIALOG = 'dialog',
  PAGE = 'page',
}

export enum TagSize {
  'NORMAL' = 'NORMAL',
  'LARGE' = 'LARGE',
  'SMALL' = 'SMALL',
}
